<template>
  <div class="flex flex-col items-center px-10 py-8 bg-gray-200 rounded gap-y-8">
    <CHeading class="flex items-center text-primary-900 gap-x-2" :level="3">
      <CIcon name="lock" size="medium" />
      {{ t('login_to_show_page_content') }}
    </CHeading>
    <CButton variant="primary" size="medium" @click="toggleAccountFlyout">
      {{ t('login') }}
    </CButton>
    <CButton variant="plain" size="medium" :href="newAccountLink" :target="newAccountLinkTarget">
      {{ t('apply_for_account') }}
    </CButton>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useUiStore, useBrandStore } from '@/stores';

const { t } = useI18n();
const { toggleAccountFlyout: toggleAccountFlyoutAction } = useUiStore();
const { brandConfig } = useBrandStore();

const newAccountLink = computed(() => brandConfig?.strings?.new_account?.link);
const newAccountLinkTarget = computed(() => (brandConfig?.strings?.new_account?.new_window ? '_blank' : '_self'));

const toggleAccountFlyout = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
  toggleAccountFlyoutAction();
};
</script>

<script lang="ts">
export default defineComponent({
  name: 'RequiresAuthenticationSection',
});
</script>
